import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "rc-tooltip/assets/bootstrap.css";
import "rc-slider/assets/index.css";
import "rc-collapse/assets/index.css";
import "rc-pagination/assets/index.css";
import "react-progress-2/main.css";
import App from "./App";
import { createGlobalStyle } from "styled-components";
import * as serviceWorker from "./serviceWorker";
import { STYLES } from "./constants";

const GlobalStyle = createGlobalStyle`  
  #wwmc-react-app-root {
    color: ${STYLES.color.black};
    font-family: ${STYLES.font.family};
    line-height: 1.5;
    
    .custom-checkbox .custom-control-label::before {
      border-radius: 0;
    }
  }
  .atv-spin {
      animation: fa-spin 1s infinite linear;
    }
    @keyframes fa-spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(359deg);
      }
    }
`;

ReactDOM.render(
  <>
    <GlobalStyle />
    <App />
  </>,
  document.getElementById("wwmc-react-app-root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
